import moment from "jalali-moment";

export const updateState = () => {
    
}
export const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
};
export const openUrl = (url) => {
    window.location.href = (url);
};

export const classNames = (classes) => {
    let out = [];
    classes.map(async (className) => {
        if(className) out.push(className)
    });
    return out.join(" ")
}

export const log = (message, ...optionalParams) => {
    if(!process.env.REACT_APP_DEBUG) return;
    if(optionalParams){
        console.log(message, optionalParams)
        return;
    }
    console.log(message)
}
export const error = (message, ...optionalParams) => {
    if(!process.env.REACT_APP_DEBUG) return;
    if(optionalParams){
        console.error(message, optionalParams)
        return;
    }
    console.error(message)
}
export const uid = (uid) => {
    if(!uid) return null;
    return uid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const formattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}
export const niceDate = (date, language = "en-US", faFormat = 'YYYY/MM/DD HH:mm:ss', enFormat = 'YYYY/MM/DD HH:mm:ss') => {
    if(!date) return null;
    const format = language.substring(0,2) === "fa"? faFormat : enFormat;
    const formattedDate = moment(date).locale(language.substring(0,2)).format(format);
    return formattedDate;
}

export const showRemainingDays = (subscription) => {
    if(!subscription) return 0;
    const diffTime = new Date(subscription.deactivated_at) - new Date();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

export const decrypt = (data) => {
    return (atob(atob(atob(data))))
}
export const encrypt = (data) => {
    return (btoa(btoa(btoa(JSON.stringify(data)))))
}
export const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return `${hrs}h ${mins?mins+"m":""} ${secs?secs+"s":""}`;
}
export const toPaymentGatewayOptions = (paymentGateways) => {
    let items = [];
    Object.keys(paymentGateways).map((id) => items.push({
        key: id,
        value: paymentGateways[id]
    }))
    return items;
    
}
export const getFirstDayOfMonth = () => {
    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    return moment(firstDayOfMonth).format("YYYY-MM-DD");
} 
export const getCurrentDayOfMonth = () => {
    const now = new Date();
    return moment(now).format("YYYY-MM-DD");
} 